export default __webpack_public_path__ + "static/media/orchata_vertical_with_title.a2383e48.svg";